// @flow

import { translate } from '../../../base/i18n';
import { ToolbarIconParticipants } from '../../../base/icons';
//import { IconUsers } from '../../../base/icons';
import { connect } from '../../../base/redux';
import { AbstractButton, type AbstractButtonProps } from '../../../base/toolbox/components';
import ChatCounter from "../../../chat/components/web/ChatCounter";
import React from "react";

/**
 * The type of the React {@code Component} props of {@link ParticipantsPaneButton}.
 */
type Props = AbstractButtonProps & {

    /**
     * Whether or not the participants pane is open.
     */
    _isOpen: boolean,
};

/**
 * Implementation of a button for accessing participants pane.
 */
class ParticipantsPaneButton extends AbstractButton<Props, *> {
    buttonLabel = 'toolbar.buttonLabel.participants';
    accessibilityLabel = 'toolbar.accessibilityLabel.participants';
    icon = ToolbarIconParticipants;
   // icon = IconUsers;
    label = 'toolbar.participants';
    tooltip = 'toolbar.participants';
    id = 'toolbar-participants';
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isOpen;
    }

    /**
     * 웹 접근성에 알맞은 focus 이동을 위해 추가
     * @returns {JSX.Element}
     */
    render(): React$Node {
        return (
            <div
                id = 'toolbar-participants'
                className = 'toolbar-button-with-badge'>
                {super.render()}
            </div>
        );
    }
}

/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {Props}
 */
function mapStateToProps(state) {
    const { isOpen } = state['features/participants-pane'];

    return {
        _isOpen: isOpen
    };
}

export default translate(connect(mapStateToProps)(ParticipantsPaneButton));
